import React, { useRef, useEffect, useState } from "react";
import { MOCK_BACKEND_URL } from "../../consts";
import Card from "./CardBlog";


const Blog = (props) => {
    const blogCardsWrapRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [data, setData] = useState([]); // Инициализация как пустой массив
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${MOCK_BACKEND_URL}/api/v1/block/blog`);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const fetchedData = await response.json();

                // Логируем данные для проверки
                console.log(fetchedData);

                // Проверяем, является ли fetchedData массивом
                if (Array.isArray(fetchedData)) {
                    setData(fetchedData);
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        const blogCardsWrap = blogCardsWrapRef.current;

        const handleMouseDown = (e) => {
            setIsDragging(true);
            setStartX(e.clientX);
        };

        const handleMouseMove = (e) => {
            if (isDragging) {
                const deltaX = e.clientX - startX;
                blogCardsWrap.scrollLeft -= deltaX; // Изменено на -= для правильной прокрутки
                setStartX(e.clientX);
            }
        };

        const handleMouseUp = () => {
            setIsDragging(false);
        };

        const handleWheel = (e) => {
            e.preventDefault();
            blogCardsWrap.scrollLeft += e.deltaY;

            // Проверяем, достигнут ли край карусели
            if (blogCardsWrap.scrollLeft === 0 || 
                blogCardsWrap.scrollLeft + blogCardsWrap.clientWidth >= blogCardsWrap.scrollWidth) {
                // Разрешаем прокрутку страницы
                window.scrollBy(0, e.deltaY);
            }
        };

        const handleTouchStart = (e) => {
            setIsDragging(true);
            setStartX(e.touches[0].clientX);
        };

        const handleTouchMove = (e) => {
            if (isDragging) {
                const deltaX = e.touches[0].clientX - startX;
                blogCardsWrap.scrollLeft -= deltaX; // Изменено на -= для правильной прокрутки
                setStartX(e.touches[0].clientX);
            }
        };

        const handleTouchEnd = () => {
            setIsDragging(false);
        };

        blogCardsWrap.addEventListener('mousedown', handleMouseDown);
        blogCardsWrap.addEventListener('mousemove', handleMouseMove);
        blogCardsWrap.addEventListener('mouseup', handleMouseUp);
        blogCardsWrap.addEventListener('mouseleave', handleMouseUp);
        blogCardsWrap.addEventListener('wheel', handleWheel);

        // Добавляем обработчики событий для касания
        blogCardsWrap.addEventListener('touchstart', handleTouchStart);
        blogCardsWrap.addEventListener('touchmove', handleTouchMove);
        blogCardsWrap.addEventListener('touchend', handleTouchEnd);

        return () => {
            blogCardsWrap.removeEventListener('mousedown', handleMouseDown);
            blogCardsWrap.removeEventListener('mousemove', handleMouseMove);
            blogCardsWrap.removeEventListener('mouseup', handleMouseUp);
            blogCardsWrap.removeEventListener('mouseleave', handleMouseUp);
            blogCardsWrap.removeEventListener('wheel', handleWheel);

            // Удаляем обработчики событий для касания
            blogCardsWrap.removeEventListener('touchstart', handleTouchStart);
            blogCardsWrap.removeEventListener('touchmove', handleTouchMove);
            blogCardsWrap.removeEventListener('touchend', handleTouchEnd);
        };
    }, [isDragging, startX]);

    return (
        <div className={`mx-auto p-4 rounded-[20px] min-h-[500px] w-full h-fit mt-[5%] flex flex-col font-manrope font-[500]`}>
            <div className="lg:mb-12 mb-8 flex flex-row justify-between w-full">
                <span className="text-[28px] xs:text-[36px] lg:text-[40px]">{props.data.header.head_title}</span>
                <div className="xs:block hidden">
                    <button
                        onClick={() => window.location.replace('/blog')}
                        className={`w-[211px] h-[48px] whitespace-nowrap group mb-auto transition duration-300 bg-[${props.data.header.button_bg_color}] text-[${props.data.header.button_text_color}] hover:bg-[#353A40] hover:text-[#FFF] border-[#1F2225] border-[1px] rounded-full px-5 py-2.5 text-[20px] flex items-center justify-between gap-2
                    active:bg-[#1F2225]`}>
                        <span className="">{props.data.header.button_text}</span>
                        <img src={props.data.header.button_arrow} alt="Arrow" className="transition duration-300 group-hover:invert" />
                    </button>

                </div>


            </div>

            <div className=" flex flex-nowrap overflow-hidden scroll-snap-x mandatory w-full gap-3" ref={blogCardsWrapRef}>
                {/* <div className={`w-3/12 min-w-[250px] xs:min-w-[400px] lg:min-w-[550px] h-[90%] flex flex-col`}> */}

                {data.map((block, index) => {
                    if (block.type === "blog_block") { // Измените условие на правильный тип блока
                        return <Card data={block.payload} />; // Передайте нужные данные в компонент
                    }
                    return null; // Возвращаем null для других типов блоков
                })}

                {/* </div> */}
                {/* <div className={`w-3/12 min-w-[250px] xs:min-w-[400px] lg:min-w-[550px] h-[90%] flex flex-col`} >
            <a href="">
                <div className={`xs:p-6 p-2 aspect-[572/507] rounded-[15px] scroll-snap-start flex-shrink-0 flex-col flex justify-between bg-no-repeat bg-center`} style={{backgroundSize: 'auto 100%', backgroundImage: `url(${props.data.member_1.bg_image})` }}>
                    <div className="ml-auto mb-auto">
                        <img src={props.data.member_1.arrowbox} alt="Arrow" className="lg:h-[52px] lg:w-[52px] h-[48px] w-[48px] xs:mr-0 xs:mt-0 mr-4 mt-4" />
                    </div>
                    <div className={`xs:w-[158px] xs:h-[72px] w-[142px] h-[59px] flex flex-col justify-between`}>
                        <div style={{backgroundColor: `${props.data.member_1.description_bg_color}`, color: `${props.data.member_1.description_color}`}} className={`h-[45%] bg-[${props.data.member_1.description_bg_color}] rounded-full flex flex-row justify-between xs:text-[14px] text-[12px] text-[${props.data.member_1.description_color}] py-1.5 px-3`}>
                            <span>•</span>
                            <span>{props.data.member_1.top_box_text}</span>
                        </div>
                        <div style={{backgroundColor: `${props.data.member_1.description_color}`, color: `${props.data.member_1.description_bg_color}`}} className={`h-[45%] bg-[${props.data.member_1.description_bg_color}] rounded-full xs:text-[14px] text-[12px] text-[${props.data.member_1.description_color}] py-1.5 px-3 w-[65%] text-nowrap`}>
                            <span>{props.data.member_1.bot_box_text}</span>
                        </div>
                    </div>
                </div>
            </a>
            <div className="lg:text-[24px] xs:text-[20px] text-[16px] mt-5 xs:mt-6"><span>{props.data.member_1.under_image_text}</span></div>
        </div> */}


                {/* <div className={`w-3/12 min-w-[250px] xs:min-w-[400px] lg:min-w-[550px] h-[90%] flex flex-col`} >
            <a href="">
                <div className={`xs:p-6 p-2 aspect-[572/507] rounded-[15px] scroll-snap-start flex-shrink-0 flex-col flex justify-between bg-no-repeat bg-center`} style={{backgroundSize: 'auto 100%', backgroundImage: `url(${props.data.member_2.bg_image})` }}>
                    <div className="ml-auto mb-auto">
                        <img src={props.data.member_2.arrowbox} alt="Arrow" className="lg:h-[52px] lg:w-[52px] h-[48px] w-[48px] xs:mr-0 xs:mt-0 mr-4 mt-4" />
                    </div>
                    <div className={`xs:w-[158px] xs:h-[72px] w-[142px] h-[59px] flex flex-col justify-between`}>
                        <div style={{backgroundColor: `${props.data.member_2.description_bg_color}`, color: `${props.data.member_2.description_color}`}} className={`h-[45%] bg-[${props.data.member_2.description_bg_color}] rounded-full flex flex-row justify-between xs:text-[14px] text-[12px] text-[${props.data.member_2.description_color}] py-1.5 px-3`}>
                            <span>•</span>
                            <span>{props.data.member_2.top_box_text}</span>
                        </div>
                        <div style={{backgroundColor: `${props.data.member_2.description_color}`, color: `${props.data.member_2.description_bg_color}`}} className={`h-[45%] bg-[${props.data.member_2.description_bg_color}] rounded-full xs:text-[14px] text-[12px] text-[${props.data.member_2.description_color}] py-1.5 px-3 w-[65%] text-nowrap`}>
                            <span>{props.data.member_2.bot_box_text}</span>
                        </div>
                    </div>
                </div>
            </a>
            
            <div className="lg:text-[24px] xs:text-[20px] text-[16px] mt-5 xs:mt-6"><span>{props.data.member_1.under_image_text}</span></div>
        </div> */}

                {/* <div className={`w-3/12 min-w-[250px] xs:min-w-[400px] lg:min-w-[550px] h-[90%] flex flex-col`}>
            <a href="">
                <div className={`xs:p-6 p-2 aspect-[572/507] rounded-[15px] scroll-snap-start flex-shrink-0 flex-col flex justify-between bg-no-repeat bg-center`} style={{backgroundSize: 'auto 100%', backgroundImage: `url(${props.data.member_3.bg_image})` }}>
                    <div className="ml-auto mb-auto">
                        <img src={props.data.member_3.arrowbox} alt="Arrow" className="lg:h-[52px] lg:w-[52px] h-[48px] w-[48px] xs:mr-0 xs:mt-0 mr-4 mt-4" />
                    </div>
                    <div className={`xs:w-[158px] xs:h-[72px] w-[142px] h-[59px] flex flex-col justify-between`}>
                        <div style={{backgroundColor: `${props.data.member_3.description_bg_color}`, color: `${props.data.member_3.description_color}`}} className={`h-[45%] bg-[${props.data.member_3.description_bg_color}] rounded-full flex flex-row justify-between xs:text-[14px] text-[12px] text-[${props.data.member_3.description_color}] py-1.5 px-3`}>
                            <span>•</span>
                            <span>{props.data.member_3.top_box_text}</span>
                        </div>
                        <div style={{backgroundColor: `${props.data.member_1.description_color}`, color: `${props.data.member_3.description_bg_color}`}} className={`h-[45%] bg-[${props.data.member_3.description_bg_color}] rounded-full xs:text-[14px] text-[12px] text-[${props.data.member_3.description_color}] py-1.5 px-3 w-[65%] text-nowrap`}>
                            <span>{props.data.member_3.bot_box_text}</span>
                        </div>
                    </div>
                </div>
            </a>
            <div className="lg:text-[24px] xs:text-[20px] text-[16px] mt-5 xs:mt-6"><span>{props.data.member_1.under_image_text}</span></div>
        </div> */}

                {/* <div className={`w-3/12 min-w-[250px] xs:min-w-[400px] lg:min-w-[550px] h-[90%] flex flex-col`} >
            <a href="">
                <div className={`xs:p-6 p-2 aspect-[572/507] rounded-[15px] scroll-snap-start flex-shrink-0 flex-col flex justify-between bg-no-repeat bg-center`} style={{backgroundSize: 'auto 100%', backgroundImage: `url(${props.data.member_4.bg_image})` }}>
                    <div className="ml-auto mb-auto">
                        <img src={props.data.member_4.arrowbox} alt="Arrow" className="lg:h-[52px] lg:w-[52px] h-[48px] w-[48px] xs:mr-0 xs:mt-0 mr-4 mt-4" />
                    </div>
                    <div className={`xs:w-[158px] xs:h-[72px] w-[142px] h-[59px] flex flex-col justify-between`}>
                        <div style={{backgroundColor: `${props.data.member_4.description_bg_color}`, color: `${props.data.member_4.description_color}`}} className={`h-[45%] bg-[${props.data.member_4.description_bg_color}] rounded-full flex flex-row justify-between xs:text-[14px] text-[12px] text-[${props.data.member_4.description_color}] py-1.5 px-3`}>
                            <span>•</span>
                            <span>{props.data.member_4.top_box_text}</span>
                        </div>
                        <div style={{backgroundColor: `${props.data.member_4.description_color}`, color: `${props.data.member_4.description_bg_color}`}} className={`h-[45%] bg-[${props.data.member_4.description_bg_color}] rounded-full xs:text-[14px] text-[12px] text-[${props.data.member_4.description_color}] py-1.5 px-3 w-[65%] text-nowrap`}>
                            <span>{props.data.member_4.bot_box_text}</span>
                        </div>
                    </div>
                </div>
            </a>
            <div className="lg:text-[24px] xs:text-[20px] text-[16px] mt-5 xs:mt-6"><span>{props.data.member_1.under_image_text}</span></div>
        </div> */}
            </div>
            <div className="xs:hidden block mt-8">
                <button
                    className={`w-[211px] h-[48px] whitespace-nowrap group mb-auto transition duration-300 bg-[${props.data.header.button_bg_color}] text-[${props.data.header.button_text_color}] hover:bg-[#353A40] hover:text-[#FFF] border-[#1F2225] border-[1px] rounded-full px-5 py-2.5 text-[20px] flex items-center justify-between gap-2
                 active:bg-[#1F2225]`}>
                    <span className="">{props.data.header.button_text}</span>
                    <img src={props.data.header.button_arrow} alt="Arrow" className="transition duration-300 group-hover:invert" />
                </button>
            </div>
        </div>

    );
}

export default Blog;
